module.exports = __webpack_public_path__ + "img/user.255c0d47.svg";